module.exports = __webpack_public_path__ + "static/geerntet-06-dfc293f8ee755e6c4b9ee911e15939cd.jpg";